import { tutoringSharedTypes } from './Constants';

const initialState = {
	loadingSubmitSignUp: false,
};

export default function tutoringSharedReducer(state = initialState, action) {
	const { type } = action;

	switch (type) {
		case tutoringSharedTypes.SIGN_UP_LIVE_LESSON_REQUEST:
			return {
				...state,
				loadingSubmitSignUp: true,
			};
		case tutoringSharedTypes.SIGN_UP_LIVE_LESSON_SUCCESS:
		case tutoringSharedTypes.SIGN_UP_LIVE_LESSON_ERROR:
			return {
				...state,
				loadingSubmitSignUp: false,
			};
		default:
			return state;
	}
}
